import React from 'react';
import { styled } from '@linaria/react';

import {
  DemoRadioControl,
  DemoSliderControl,
} from '@/components/Demo';

import FlexDemo from './FlexDemo';

function SearchField({ solvable }) {
  const id = React.useId();

  const [maxWidth, setMaxWidth] = React.useState(null);

  React.useEffect(() => {
    const maxAvailableWidth =
      document.documentElement.clientWidth - 32 - 16;

    if (maxAvailableWidth < 500) {
      setMaxWidth(maxAvailableWidth);
    } else {
      setMaxWidth(500);
    }
  }, []);

  if (!maxWidth) {
    return null;
  }

  return (
    <FlexDemo
      centered={true}
      customGrid={{
        gridTemplateColumns: solvable ? '1fr 1fr' : '1fr',
      }}
      initialValues={{
        minWidth: 'auto',
        containerWidth: maxWidth,
      }}
      controls={[
        !!solvable && (
          <DemoRadioControl
            key="minWidth"
            id="minWidth"
            label="min-width"
            options={[
              { label: 'auto (default)', value: 'auto' },
              '0px',
            ]}
            wrapperStyle={{
              width: 284,
              color: 'hsl(50deg 100% 65%)',
              fontWeight: 'var(--font-weight-medium)',
            }}
          />
        ),
        <DemoSliderControl
          key="containerWidth"
          id="containerWidth"
          label="Container width"
          min={180}
          max={maxWidth}
          wrapperStyle={{ width: 284 }}
        />,
      ]}
    >
      {({ minWidth, containerWidth }) => (
        <Wrapper style={{ width: containerWidth }}>
          <Form
            onSubmit={(event) => {
              event.preventDefault();
              alert("This isn't a real search form :(");
            }}
          >
            <Label htmlFor={`flex-demo-search-field-${id}`}>
              Search:
            </Label>
            <SearchInput
              id={`flex-demo-search-field-${id}`}
              placeholder="Fancy shoes"
              style={{ minWidth }}
            />
          </Form>
        </Wrapper>
      )}
    </FlexDemo>
  );
}

const Wrapper = styled.div`
  border-radius: 4px;
  padding: 16px;
  outline: 1px solid var(--color-gray-400);
  background: var(--color-gray-100);
`;

const Form = styled.form`
  display: flex;
  align-items: center;
  gap: 16px;

  &:focus-within {
    outline-offset: 16px;
    outline: 2px auto;
    outline-color: Highlight;
    outline-color: -webkit-focus-ring-color;
  }
`;

const Label = styled.label`
  font-weight: var(--font-weight-medium);
`;

const SearchInput = styled.input`
  height: 32px;
  flex: 1;
  background: var(--color-gray-100);
  border: none;
  border-bottom: 2px solid var(--color-text);
  color: var(--color-text);
  outline: none;
  border-radius: 2px;
`;

export default SearchField;
